import { create } from 'zustand'

export interface ToastItem {
  id: number
  message: string
  tone: 'good' | 'bad'
}

interface ToastStore {
  items: ToastItem[]
  push: (message: string, tone?: 'good' | 'bad') => void
}

let seq = 0

export const useToast = create<ToastStore>((set) => ({
  items: [],
  push: (message, tone = 'good') => {
    const id = ++seq
    set((s) => ({ items: [...s.items, { id, message, tone }] }))
    setTimeout(() => set((s) => ({ items: s.items.filter((i) => i.id !== id) })), 3800)
  },
}))
